import script from "./PackageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageView.vue?vue&type=script&lang=ts&setup=true"

import "./PackageView.vue?vue&type=style&index=0&id=cdefb4aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdefb4aa"]])

export default __exports__